import React from "react";
import MiniaturaMagazzino from "./MiniaturaMagazzino";
import { statoLetturaAtteso } from "./sessioniLocali";

const ordine = a => a?.ordine != null ? `Ord PS ${a.fonte}-${a.ordine}` : "—";

export function RigaLetturaMagazzino({ lettura: l, selezionata, onSeleziona }) {
  const a=l.presentazione;
  const valida=["VALIDA","FUORI_ATTESI"].includes(l.esito) && !l.confermata;
  return <tr><td><input aria-label={`Seleziona lettura ${l.id}`} type="checkbox" disabled={!valida} checked={selezionata} onChange={e=>onSeleziona(e.target.checked)}/></td>
    <td>{l.barcode || `Manuale · pezzo ${l.id_unita}`}<br/><small>Prodotto: {l.barcode_prodotto || "—"}</small></td>
    <td><div className="mag-articolo"><MiniaturaMagazzino articolo={a}/><div className="mag-articolo-testo"><strong>{a?.codice_vs || "—"}</strong><div>{a?.descrizione || l.dettaglio?.descrizione}</div></div></div></td>
    <td><div>{ordine(a || l.dettaglio)}</div><div>{a?.destinatario || "—"}</div></td>
    <td><strong>{l.confermata?"CONFERMATA":l.esito.replaceAll("_"," ")}</strong><br/>{l.dettaglio?.messaggio}</td></tr>;
}

export function RigaAttesoMagazzino({ unita: u, letture, pending, azione, manualeDisabilitato, onManuale }) {
  const a=u.presentazione;
  const letta=statoLetturaAtteso(u,letture,pending,azione);
  return <tr className={letta ? "mag-atteso-letto" : undefined}>
    <td><div>Ord PS {u.fonte}-{u.N_rif_PrestaShop}</div>
      <div>{a?.barcode_matricola || (u.provenienza==="CUSTOM" ? "Fuori circuito" : "Matricola non univoca o non disponibile")}</div>
      {letta && <strong className="db mag-lettura-label">{letta}</strong>}</td>
    <td><div className="mag-articolo"><MiniaturaMagazzino articolo={a}/><div className="mag-articolo-testo"><strong>{a?.codice_vs || u.codice_vs}</strong><div>{a?.descrizione || u.descrizione}</div></div></div></td>
    <td>{u.corrente?.coerente?u.corrente.stato:"DA RIVERIFICARE"}</td>
    <td>{u.provenienza==="CUSTOM" ? <select aria-label={`Stato manuale pezzo ${u.id}`} value="" disabled={manualeDisabilitato} onChange={e=>onManuale(e.target.value)}>
      <option value="">Proponi stato…</option><option>DA_TROVARE</option><option>TROVATO</option><option>PRONTO</option></select> : "—"}</td></tr>;
}
